import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ChatBubbleCustomizer = ({ bubbleIcon, bubbleColor, onIconChange, onColorChange }) => {
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [showIconPicker, setShowIconPicker] = useState(false);

  const iconOptions = [
    'MessageCircle', 'MessageSquare', 'Bot', 'Headphones', 'HelpCircle',
    'Phone', 'Mail', 'Zap', 'Heart', 'Star', 'Smile', 'Users'
  ];

  const colorPresets = [
    '#21b17a', '#3b82f6', '#8b5cf6', '#f59e0b', '#ef4444',
    '#10b981', '#06b6d4', '#84cc16', '#f97316', '#ec4899',
    '#6366f1', '#14b8a6', '#eab308', '#dc2626', '#9333ea'
  ];

  const handleColorSelect = (color) => {
    onColorChange(color);
    setShowColorPicker(false);
  };

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-foreground">Chat-Bubble Anpassung</h3>
      {/* Icon Selection */}
      <div className="space-y-3">
        <label className="text-sm font-medium text-foreground">Symbol</label>
        <div className="flex items-center space-x-3">
          <div 
            className="w-12 h-12 rounded-full flex items-center justify-center cursor-pointer transition-all duration-200 hover:scale-105"
            style={{ backgroundColor: bubbleColor }}
            onClick={() => setShowIconPicker(!showIconPicker)}
          >
            <Icon name={bubbleIcon} size={24} color="white" />
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={() => setShowIconPicker(!showIconPicker)}
            iconName="Edit"
            iconPosition="left"
          >
            Symbol ändern
          </Button>
        </div>

        {showIconPicker && (
          <div className="p-4 border border-border rounded-lg bg-card">
            <div className="grid grid-cols-6 gap-2">
              {iconOptions?.map((icon) => (
                <button
                  key={icon}
                  onClick={() => {
                    onIconChange(icon);
                    setShowIconPicker(false);
                  }}
                  className={`
                    w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-200
                    ${bubbleIcon === icon 
                      ? 'bg-primary text-primary-foreground' 
                      : 'bg-muted hover:bg-muted-foreground/10 text-muted-foreground hover:text-foreground'
                    }
                  `}
                >
                  <Icon name={icon} size={20} />
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
      {/* Color Selection */}
      <div className="space-y-3">
        <label className="text-sm font-medium text-foreground">Farbe</label>
        <div className="flex items-center space-x-3">
          <div 
            className="w-12 h-12 rounded-lg border-2 border-border cursor-pointer transition-all duration-200 hover:scale-105"
            style={{ backgroundColor: bubbleColor }}
            onClick={() => setShowColorPicker(!showColorPicker)}
          />
          <div className="flex-1">
            <input
              type="text"
              value={bubbleColor}
              onChange={(e) => onColorChange(e?.target?.value)}
              className="w-full px-3 py-2 border border-border rounded-md bg-background text-foreground font-mono text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
              placeholder="#21b17a"
            />
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={() => setShowColorPicker(!showColorPicker)}
            iconName="Palette"
          />
        </div>

        {showColorPicker && (
          <div className="p-4 border border-border rounded-lg bg-card">
            <div className="space-y-4">
              <div>
                <label className="text-xs font-medium text-muted-foreground mb-2 block">
                  Vordefinierte Farben
                </label>
                <div className="grid grid-cols-5 gap-2">
                  {colorPresets?.map((color) => (
                    <button
                      key={color}
                      onClick={() => handleColorSelect(color)}
                      className={`
                        w-10 h-10 rounded-lg border-2 transition-all duration-200 hover:scale-105
                        ${bubbleColor === color ? 'border-foreground' : 'border-border'}
                      `}
                      style={{ backgroundColor: color }}
                      title={color}
                    />
                  ))}
                </div>
              </div>
              
              <div>
                <label className="text-xs font-medium text-muted-foreground mb-2 block">
                  Benutzerdefinierte Farbe
                </label>
                <input
                  type="color"
                  value={bubbleColor}
                  onChange={(e) => onColorChange(e?.target?.value)}
                  className="w-full h-10 border border-border rounded-md cursor-pointer"
                />
              </div>
            </div>
          </div>
        )}
      </div>
      {/* Preview */}
      <div className="p-4 bg-muted rounded-lg">
        <p className="text-xs font-medium text-muted-foreground mb-3">Vorschau</p>
        <div className="flex justify-end">
          <div 
            className="w-14 h-14 rounded-full flex items-center justify-center shadow-lg cursor-pointer transition-all duration-200 hover:scale-105"
            style={{ backgroundColor: bubbleColor }}
          >
            <Icon name={bubbleIcon} size={28} color="white" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatBubbleCustomizer;